export default __webpack_public_path__ + "static/media/TimeElapse.b10edcda.jpg";